/* assets/color-swatch-picker.js */
(function () {
  'use strict';

  // Finds the native option control(s) for the color option and drives them,
  // so this theme's existing variant pipeline (image/price/SKU/cart button)
  // updates itself exactly as it does for the native picker.
  function selectNativeVariant(container, colorIndex, colorValue) {
    var sectionId = container.getAttribute('data-section-id');
    if (!sectionId) return false;

    var selector = '.single-option-selector-' + sectionId + '[data-index="' + colorIndex + '"]';
    var elements = container.querySelectorAll(selector);
    var didUpdate = false;

    elements.forEach(function (el) {
      if (el.type === 'radio' || el.type === 'checkbox') {
        if (el.value === colorValue) {
          el.checked = true;
          el.dispatchEvent(new Event('change', { bubbles: true }));
          didUpdate = true;
        }
      } else if (el.tagName === 'SELECT') {
        el.value = colorValue;
        el.dispatchEvent(new Event('change', { bubbles: true }));
        didUpdate = true;
      }
    });

    return didUpdate;
  }

  // Reads the currently selected value of every non-color option (e.g.
  // Packaging: Boxed / Fully Assembled) and builds the same "option1|option2|"
  // style signature used server-side, so we can look up the right price.
  function getCurrentOtherSignature(container, colorIndex) {
    var sectionId = container.getAttribute('data-section-id');
    var sig = '';

    ['option1', 'option2', 'option3'].forEach(function (idx) {
      if (idx === colorIndex) return;

      var selector = '.single-option-selector-' + sectionId + '[data-index="' + idx + '"]';
      var elements = container.querySelectorAll(selector);
      var value = '';

      elements.forEach(function (el) {
        if (el.type === 'radio' || el.type === 'checkbox') {
          if (el.checked) value = el.value;
        } else if (el.tagName === 'SELECT') {
          value = el.value;
        }
      });

      sig += value + '|';
    });

    return sig;
  }

  // Updates every swatch's displayed price to match whichever Packaging (or
  // other non-color option) is currently selected.
  function updateSwatchPrices(picker) {
    var container = picker.closest('[data-section-id]');
    if (!container) return;

    var colorIndex = picker.getAttribute('data-color-key');
    var signature = getCurrentOtherSignature(container, colorIndex);

    picker.querySelectorAll('[data-color-swatch-item]').forEach(function (button) {
      var pricesJson = button.getAttribute('data-prices');
      if (!pricesJson) return;

      var prices;
      try {
        prices = JSON.parse(pricesJson);
      } catch (e) {
        return;
      }

      var price = prices[signature];
      if (price == null) return;

      button.setAttribute('data-price', price);
      var priceEl = button.querySelector('.color-swatch-item__price');
      if (priceEl) priceEl.textContent = price;
    });
  }

  function handleSwatchClick(picker, button) {
    var variantId = button.getAttribute('data-variant-id');
    var colorName = button.getAttribute('data-color-name');
    var colorIndex = picker.getAttribute('data-color-key');
    if (!variantId || !colorIndex) return;

    var container = picker.closest('[data-section-id]');

    picker.querySelectorAll('[data-color-swatch-item]').forEach(function (el) {
      el.classList.remove('is-active');
      el.setAttribute('aria-pressed', 'false');
    });
    button.classList.add('is-active');
    button.setAttribute('aria-pressed', 'true');

    var nameEl = picker.querySelector('[data-color-swatch-current-name]');
    if (nameEl) nameEl.textContent = colorName;

    if (container) {
      selectNativeVariant(container, colorIndex, colorName);
    }

    picker.dispatchEvent(
      new CustomEvent('color-swatch:change', {
        bubbles: true,
        detail: { variantId: variantId, colorName: colorName }
      })
    );
  }

  function initPicker(picker) {
    picker.addEventListener('click', function (event) {
      var button = event.target.closest('[data-color-swatch-item]');
      if (!button || !picker.contains(button)) return;
      handleSwatchClick(picker, button);
    });

    // Make sure prices are correct for whatever is selected at page load too.
    updateSwatchPrices(picker);
  }

  // Delegate at the document level (rather than a container found once at
  // init time) so this reliably catches every native option change,
  // including ones on elements that get re-rendered after init.
  function handleOptionChange(event) {
    var target = event.target;
    if (!target || !target.hasAttribute || !target.hasAttribute('data-index')) return;

    document.querySelectorAll('[data-color-swatch-picker]').forEach(function (picker) {
      var container = picker.closest('[data-section-id]');
      if (!container || !container.contains(target)) return;

      var colorIndex = picker.getAttribute('data-color-key');
      if (target.getAttribute('data-index') === colorIndex) return; // color changes don't affect the price map

      updateSwatchPrices(picker);
    });
  }

  function init() {
    document.querySelectorAll('[data-color-swatch-picker]').forEach(initPicker);
    document.addEventListener('change', handleOptionChange, true);
    document.addEventListener('input', handleOptionChange, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
